<template>
	<section>

        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="showAdd">Add Service Fee</el-button>
                    <el-button type="primary" @click="showUserRate">User Rate</el-button>
                </el-form-item>
            </el-form>
        </el-col>

		<!--列表-->
		<el-table stripe :data="serviceFees" highlight-current-row v-loading="firstLoading" style="width: 100%;">
			<el-table-column prop="serviceLabel" label="Label" >
			</el-table-column>
			<el-table-column prop="serviceBaseFee" label="Service Fee">
			</el-table-column>
            <el-table-column prop="serviceDesc" label="Desc">
            </el-table-column>
			<el-table-column label="Action">
                <template slot-scope="scope">
                    <el-button size="small" @click="showEdit(scope.row)">Edit</el-button>
                </template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handlePageChange" :page-size="pageSize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

        <!--添加界面-->
        <el-dialog title="Add Category" width="80%" :visible.sync="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addServiceFee" label-width="220px" :rules="formRules" ref="addServiceFee">
                <el-form-item label="Label" prop="serviceLabel">
                    <el-input v-model="addServiceFee.serviceLabel" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Service Fee" prop="serviceBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="addServiceFee.serviceBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Desc" prop="serviceDesc">
                    <el-input v-model="addServiceFee.serviceDesc" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">Close</el-button>
                <el-button type="primary" @click.native="handleAddServiceFee" :loading="editLoading">Submit</el-button>
            </div>
        </el-dialog>

        <!--修改界面-->
        <el-dialog title="Edit Category" width="80%" :visible.sync="editVisible" :close-on-click-modal="false">
            <el-form :model="editServiceFee" label-width="220px" :rules="editFormRules" ref="editServiceFee">
                <el-form-item label="Label" prop="serviceLabel">
                    <el-input v-model="editServiceFee.serviceLabel" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Service Fee" prop="serviceBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="editServiceFee.serviceBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Desc" prop="serviceDesc">
                    <el-input v-model="editServiceFee.serviceDesc" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editVisible = false">Close</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">Submit</el-button>
            </div>
        </el-dialog>

        <!--Service Fee User表列界面-->
        <el-dialog title="User Rate List" width="80%" :visible.sync="userRateVisible" :close-on-click-modal="false">
            <!--列表-->
            <el-table stripe :data="userRates" highlight-current-row v-loading="secondLoading" style="width: 100%;">
                <el-table-column prop="doctorName" label="Doctor" >
                </el-table-column>
                <el-table-column prop="hasSingleSeted" label="Has bean set" >
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.hasSingleSeted ? "Already Set" : "Not Set" }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button size="small" @click="showServiceFeeEdit(scope.row.doctorNo)">Edit</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="userRateVisible = false">Close</el-button>
            </div>
        </el-dialog>

        <!--Custom Service Fee特殊价格设置界面-->
        <el-dialog title="Custom Service Fee Set" width="80%" :visible.sync="customServiceFeeVisible" :close-on-click-modal="false">
            <!--列表-->
            <el-table stripe :data="customServiceFeeConfigs" highlight-current-row v-loading="thirdLoading" style="width: 100%;">
                <el-table-column prop="serviceLabel" label="Service Label" >
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.serviceLabel }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="serviceBaseFee" label="Service Fee">
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.serviceBaseFee }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="serviceDesc" label="Description">
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.serviceDesc }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button size="small" @click="showCustomEdit(scope.row)">Edit</el-button>
                        <el-button size="small" @click="deleteCustomItem(scope.row)" v-if="scope.row.hasSingleSeted">Restore</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="customServiceFeeVisible = false;getAllUserRate()">Close</el-button>
            </div>
        </el-dialog>

        <!--修改界面-->
        <el-dialog title="Custom Edit Service Fee" width="80%" :visible.sync="customEditVisible" :close-on-click-modal="false">
            <el-form :model="customEditServiceFee" label-width="220px" :rules="editFormRules" ref="customEditServiceFee">
                <el-form-item label="Service Label" prop="serviceLabel">
                    <el-input v-model="customEditServiceFee.serviceLabel" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Service Fee" prop="serviceBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="customEditServiceFee.serviceBaseFee"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="customEditVisible = false">Close</el-button>
                <el-button type="primary" @click.native="customEditSubmit" :loading="customEditLoading">Submit</el-button>
            </div>
        </el-dialog>

	</section>
</template>


<script>
    import util from '../../common/js/util'
    import {defaultPageSize} from "../../globalVar";
    import {editServiceFee, getServiceFeeList, getServiceFeeById} from "../../api/serviceFeeService";
    import {
        deleteCustomServiceFeeConfigs,
        editCustomServiceFeeConfigs,
        editCustomServiceFeeConfigsDiscount, getCustomServiceFeeById,
        getCustomServiceFeeList,
        getDoctorUserList
    } from "../../api/customServiceFeeConfigService";

    export default {
        data() {
            return {
                firstLoading: false,
                pageSize:defaultPageSize,

                activeName:"first",

                filters: {
                    email: ''
                },

                serviceFees: [],

                userRates: [],

                customServiceFeeConfigs: [],

                total:0,
                page:1,

                editVisible: false,//编辑界面是否显示
                secondLoading: false,
                thirdLoading: false,
                customEditLoading: false,

                editLoading: false,
                editFormRules: {
                    serviceLabel: [
                        { required: true, message: 'Label is required.', trigger: 'blur' }
                    ]
                },

                //新增界面数据
                addServiceFee: {
                    serviceLabel: "",
                    serviceBaseFee: 0.0,
                    serviceDesc: "",
                    id:null
                },
                //编辑界面数据
                editServiceFee: {
                    serviceLabel: "",
                    serviceBaseFee: 0.0,
                    serviceDesc: "",
                    id:null
                },

                addFormVisible: false,//新增界面是否显示
                // addLoading: false,
                formRules: {
                    serviceLabel: [
                        { required: true, message: 'Label is required.', trigger: 'blur' }
                    ]
                },
                
                userRateVisible: false,//Category User表列界面是否显示
                customServiceFeeVisible: false, // 神医自定义ServiceFee设置界面是否显示
                
                editDoctorNo: '', // 等待编辑的神医ID

                customEditVisible: false,
                customEditServiceFee: {
                    serviceFeeId: null,
                    doctorNo: "",
                    serviceBaseFee: 0.0,
                    id:null
                },

            }
        },
        methods: {
            formatHasBeanSet(row, column) {
                if (row.hasSingleSeted === true) {
                    return "Already Set";
                } else {
                    return "Not Set";
                }
            },
            handlePageChange(val) {
                this.page = val;
                this.getServiceFeeList();
            },
            handleAddServiceFee(){
                this.$refs.addServiceFee.validate((valid)=>{
                    if(valid){
                        this.loading= true;
                        let param = {
                            serviceLabel: this.addServiceFee.serviceLabel,
                            serviceBaseFee: this.addServiceFee.serviceBaseFee,
                            serviceDesc: this.addServiceFee.serviceDesc,
                            id: null
                        };
                        editServiceFee(param).then((res)=>{
                            this.loading= false;
                            if(res.status===200){
                                this.addFormVisible = false;
                                this.$message.success(res.message);
                                this.$refs.addServiceFee.resetFields();
                                this.getServiceFeeList();
                            }else{
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                })
                            }
                        })
                    }
                })
            },
            showAdd(){
                this.addFormVisible = true;
                this.addServiceFee.id = null;
                this.addServiceFee.serviceLabel = "";
                this.addServiceFee.serviceBaseFee = 0;
                this.addServiceFee.serviceDesc = "";
            },
            showEdit(row){
                getServiceFeeById(row).then((res)=>{
                    if(res.status===200){
                        this.editVisible = true;
                        this.editServiceFee =  res.result;
                    }
                });
            },
            editSubmit(){
                this.editLoading = true;
                let para = {
                    serviceLabel: this.editServiceFee.serviceLabel,
                    serviceBaseFee: this.editServiceFee.serviceBaseFee,
                    serviceDesc: this.editServiceFee.serviceDesc,
                    id: this.editServiceFee.id
                };
                editServiceFee(para).then((res)=>{
                    this.editLoading = false;
                    if(res.status===200){
                        this.$message({
                            message:res.message,
                            type:"success"
                        });
                        this.getServiceFeeList();
                        this.editVisible = false;
                    }else{
                        this.$message({
                            message:res.message,
                            type:"error"
                        })
                    }
                })
            },
            getServiceFeeList(){
                let para = {
                    current: this.page,
                    size:this.pageSize
                };

                this.firstLoading = true;
                getServiceFeeList(para).then(res=>{
                    this.firstLoading = false;
                    if(res.status===200){
                        this.serviceFees = res.result.records;
                        this.total = res.result.total;
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            showUserRate(){
                this.userRateVisible = true;
                this.getAllUserRate();
            },
            showServiceFeeEdit(rowDoctorNo){
                this.customServiceFeeVisible = true;;
                this.getDoctorCustomServiceFeeRate(rowDoctorNo);
            },
            getAllUserRate(){
                let para = {
                    current: 1,
                    size: 1000
                };

                this.secondLoading = true;
                getDoctorUserList(para).then(res=>{
                    this.secondLoading = false;
                    if(res.status===200){
                        this.userRates = res.result.records;
                        this.total = res.result.total;
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            getDoctorCustomServiceFeeRate(rowDoctorNo){
                let para = {
                    current: 1,
                    size: 1000,
                    doctorNo: rowDoctorNo
                };

                this.thirdLoading = true;
                getCustomServiceFeeList(para).then(res=>{
                    this.thirdLoading = false;
                    if(res.status===200){
                        this.customServiceFeeConfigs = res.result;
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            showCustomEdit(row){
                let para = {
                    doctorNo: row.doctorNo,
                    serviceFeeId: row.serviceFeeId,
                    id: row.id
                };
                getCustomServiceFeeById(para).then((res)=>{
                    if(res.status===200){
                        this.customEditVisible = true;
                        this.customEditServiceFee = res.result;
                    }
                });
            },
            deleteCustomItem(row) {
                this.editLoading = true;
                let para = {
                    doctorNo: row.doctorNo,
                    serviceFeeId: row.serviceFeeId,
                    id: row.id
                };
                deleteCustomServiceFeeConfigs(para).then((res)=>{
                    this.editLoading = false;
                    if(res.status===200){
                        this.$message({
                            message:res.message,
                            type:"success"
                        });
                        this.showServiceFeeEdit(row.doctorNo);
                        this.editVisible = false;
                    }else{
                        this.$message({
                            message:res.message,
                            type:"error"
                        })
                    }
                })
            },
            customEditSubmit(){
                this.customEditLoading = true;
                let para = {
                    serviceFeeId: this.customEditServiceFee.serviceFeeId,
                    serviceLabel: this.customEditServiceFee.serviceLabel,
                    serviceDesc: this.customEditServiceFee.serviceDesc,
                    doctorNo: this.customEditServiceFee.doctorNo,
                    serviceBaseFee: this.customEditServiceFee.serviceBaseFee,
                    id: this.customEditServiceFee.id
                };
                editCustomServiceFeeConfigs(para).then((res)=>{
                    this.customEditLoading = false;
                    this.customEditVisible = false;
                    if(res.status===200){
                        this.$message({
                            message:res.message,
                            type:"success"
                        });
                        this.getDoctorCustomServiceFeeRate(this.customEditServiceFee.doctorNo);
                    }else{
                        this.$message({
                            message:res.message,
                            type:"error"
                        })
                    }
                })
            },
        },
        mounted() {
            this.getServiceFeeList();
        }
    }

</script>


// WEBPACK FOOTER //
// serviceFeeConfig.vue?32b846be